import _ from "lodash";
import * as Yup from "yup";
import { toUTCISOString } from "../../../utils/timeZone";

export const defaultValues = {
  reportFrom: null,
  reportTo: null,
  generatedAt: null,
};
export const schema = Yup.object().shape({
  reportFrom: Yup.date().nullable(),
  reportTo: Yup.date().nullable(),
  generatedAt: Yup.date().nullable(),
});

export const sanitizeFilters = ({ reportFrom, reportTo, generatedAt }) => {
  return _.pickBy(
    {
      reportFrom: reportFrom && toUTCISOString(reportFrom),
      reportTo: reportTo && toUTCISOString(reportTo),
      generatedAt: generatedAt && toUTCISOString(generatedAt),
    },
    _.identity
  );
};
